import script from "./BaoYouLiangSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaoYouLiangSearch.vue?vue&type=script&lang=ts&setup=true"

import "./BaoYouLiangSearch.vue?vue&type=style&index=0&id=405a1d7e&lang=scss"

const __exports__ = script;

export default __exports__